import { format } from "date-fns";

export const restageMojoItemsColumns = [
  {
    field: "regionName",
    header: "Region",
    minWidth: "8rem",
    sort: false
  },
  {
    field: "poNumber",
    header: "PO Number",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "customerId",
    header: "Customer ID",
    minWidth: "10rem",
    sort: false
  },
  {
    field: "trackerStatus",
    header: "File Status Before D365",
    minWidth: "20rem",
    sort: true
  },
  {
    field: "trackerFOStatus",
    header: "File Status After D365",
    minWidth: "20rem",
    sort: true
  },

  {
    field: "messageId",
    header: "Message ID",
    minWidth: "24rem",
    sort: false
  },
  {
    field: "salesOrigin",
    header: "Sales Origin",
    minWidth: "10rem",
    sort: false
  },
  {
    field: "messageType",
    header: "Message Type",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "fileProcessedDatePst",
    header: "File Processed",
    minWidth: "10rem",
    sort: true,
    body: (rowData) => {
      if (!rowData?.fileProcessedDatePst) return "";
      return format(
        new Date(rowData?.fileProcessedDatePst),
        "MM/dd/yyyy, hh:mm:ss a"
      );
    }
  },
  {
    field: "createdDatePst",
    header: "Created Date",
    minWidth: "10rem",
    sort: true,
    body: (rowData) => {
    if (!rowData?.createdDatePst) return "";
     return format(
      new Date(rowData?.createdDatePst),
      "MM/dd/yyyy, hh:mm:ss a"
    );
  }
  },
  {
    field: "lastAttemptPst",
    header: "Last Updated Date",
    minWidth: "10rem",
    sort: true,
    body: (rowData) => {
    if (!rowData?.lastAttemptPst) return "";
    return format(
      new Date(rowData?.lastAttemptPst),
      "MM/dd/yyyy, hh:mm:ss a"
    );
  }}
];

export const excludedRestageMojoItemsColumns = [
  {
    field: "regionName",
    header: "Region",
    minWidth: "8rem",
    sort: false
  },
  {
    field: "poNumber",
    header: "PO Number",
    minWidth: "12rem",
    sort: true
  },
   {
    field: "customerId",
    header: "Customer ID",
    minWidth: "10rem",
    sort: false
  },
   {
    field: "salesOrigin",
    header: "Sales Origin",
    minWidth: "8rem",
    sort: false
  },
   {
    field: "trackerFOStatus",
    header: "File Status After D365",
    minWidth: "14rem",
    sort: true
  },
]